export const baseURL = "https://staging.popsicle.ly/api";
// export const baseURL = "http://testing.popsicle.ly/api";
// export const baseURL = "http://localhost:4000/";
